import {Component, ComponentRef, Injector, OnInit, Type, ViewChild, ViewContainerRef} from "@angular/core";
import {BaseDialog} from "../BaseDialog";
import {DialogService} from "../../../services/dialog.service";
import {ToastrService} from "ngx-toastr";
import { SyncService } from "../../../services/sync.service";
import { AccessRights, UsersService, InterfacePermissions } from "../../../services/users.service";
import { CompaniesService } from "app/services/companies.service";

@Component({
    selector: 'app-base-component-with-dialog',
    template: '',
    standalone: false
})
export class BaseComponentWithDialog implements OnInit {
  public AccessRights = AccessRights;
  public InterfacePermissions = InterfacePermissions;

  @ViewChild("mgmtDialog", { static: true, read: ViewContainerRef }) container;
  protected componentRef: ComponentRef<any>;
  protected dialogService: DialogService;
  protected syncService: SyncService;
  public usersService: UsersService;
  public companyService: CompaniesService;

  protected Refresh() {
  };

  protected toastr: ToastrService;

  constructor(protected injector: Injector) {
    this.dialogService = injector.get(DialogService);
    this.toastr = injector.get(ToastrService);
    this.syncService = injector.get(SyncService);
    this.usersService = injector.get(UsersService);
    this.companyService = injector.get(CompaniesService);
  }

  protected onCreated() {
    this.Refresh();
  }

  protected prepareModal<T>(dialogType: Type<BaseDialog>) {
    this.componentRef = this.dialogService.open(this.container, dialogType);
    if (this.componentRef.instance.onCreated) {
      this.componentRef.instance.onCreated.subscribe(() => {
        this.onCreated()
      });
    }
    if (this.componentRef.instance.onClose) {
      this.componentRef.instance.onClose.subscribe(() => {
        this.Refresh();
      });
    }
  }

  public canAccessComponent(rights: AccessRights): boolean {
    return this.usersService.IsPermitted(rights);
  }

  ngOnInit(): void {
    this.Refresh();
  }
}
